// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-menu-button {
  display: flex;
  justify-content: center;
  font-size: 26px;
  margin-bottom: 3px;
  cursor: pointer;
  background-color: #333;
  z-index: 3;
}

.global-menu {
  position: absolute;
  top: 0;
  right: 0;
  width: 360px;
  height: 100vh;
  z-index: 10000000;
  background-color: #121212;
  transition: right 200ms;

  .global-menu-item {
    cursor: pointer;
    font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;
    font-size: 14px;
    border-bottom: 1px solid #333;
    padding: 4px 2px;
  }

  global-menu-item:hover {
    background-color: #666;
  }

  .retract-global-menu-button {
    width: 100%;
    font-size: 25px;
    text-align: left;
    padding-right: 8px;
  }

  .login-status {
    margin-top: 8px;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: center;
  }

  .logged-in-wrapper {
    display: flex;
    flex-direction: column;
    margin-top: -10px;

    button {
      margin-top: 2px;
    }
  }

  .latency-hint-dirty-message {
    font-family: 'IBM Plex Sans', 'Open Sans', 'Roboto', sans-serif;
    font-style: italic;
    font-size: 14px;
    margin-top: 4px;
    display: block;
    margin-bottom: 4px;
  }
}

.global-tempo-control {
  display: flex;
  border-bottom: 1px solid #333;

  p {
    font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;
    font-size: 13.5px;
    margin: 0;
    padding: 4px 2px;
  }

  input {
    font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;
    background: #252525;
    color: #eee;
    padding: 4px;
    height: 24px;
    width: 126px;
    text-align: center;
    margin-left: 12px;
    border: 1px solid #6a6a6a;
    box-sizing: border-box;
  }
}

.global-menu-backdrop {
  background-color: transparent;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9999999;
  left: 0;
  top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/globalMenu/GlobalMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;;EAEvB;IACE,eAAe;IACf,oEAAoE;IACpE,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;;IAEjB;MACE,eAAe;IACjB;EACF;;EAEA;IACE,+DAA+D;IAC/D,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,6BAA6B;;EAE7B;IACE,oEAAoE;IACpE,iBAAiB;IACjB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,oEAAoE;IACpE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,OAAO;EACP,MAAM;AACR","sourcesContent":[".global-menu-button {\n  display: flex;\n  justify-content: center;\n  font-size: 26px;\n  margin-bottom: 3px;\n  cursor: pointer;\n  background-color: #333;\n  z-index: 3;\n}\n\n.global-menu {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 360px;\n  height: 100vh;\n  z-index: 10000000;\n  background-color: #121212;\n  transition: right 200ms;\n\n  .global-menu-item {\n    cursor: pointer;\n    font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;\n    font-size: 14px;\n    border-bottom: 1px solid #333;\n    padding: 4px 2px;\n  }\n\n  global-menu-item:hover {\n    background-color: #666;\n  }\n\n  .retract-global-menu-button {\n    width: 100%;\n    font-size: 25px;\n    text-align: left;\n    padding-right: 8px;\n  }\n\n  .login-status {\n    margin-top: 8px;\n    padding-left: 10px;\n    padding-right: 10px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .logged-in-wrapper {\n    display: flex;\n    flex-direction: column;\n    margin-top: -10px;\n\n    button {\n      margin-top: 2px;\n    }\n  }\n\n  .latency-hint-dirty-message {\n    font-family: 'IBM Plex Sans', 'Open Sans', 'Roboto', sans-serif;\n    font-style: italic;\n    font-size: 14px;\n    margin-top: 4px;\n    display: block;\n    margin-bottom: 4px;\n  }\n}\n\n.global-tempo-control {\n  display: flex;\n  border-bottom: 1px solid #333;\n\n  p {\n    font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;\n    font-size: 13.5px;\n    margin: 0;\n    padding: 4px 2px;\n  }\n\n  input {\n    font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;\n    background: #252525;\n    color: #eee;\n    padding: 4px;\n    height: 24px;\n    width: 126px;\n    text-align: center;\n    margin-left: 12px;\n    border: 1px solid #6a6a6a;\n    box-sizing: border-box;\n  }\n}\n\n.global-menu-backdrop {\n  background-color: transparent;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999999;\n  left: 0;\n  top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
